import Swiper from 'swiper/bundle';

jQuery(function ($) {
    const $section = $('.section-slider-news');
    const $slider  = $section.find('.slider-news');
    const $mainTitle = $section.find('.slider-news-main-title');

    if (!$slider.length) return;

    let swiper;
    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    let fsActive = false;
    let titleAnimating = false;
    let pendingTitle = null;

    function getSlideTitleByRealIndex(realIndex) {
        const $originalSlide = $slider.find(`.swiper-slide[data-swiper-slide-index="${realIndex}"]`).not('.swiper-slide-duplicate').first();

        if ($originalSlide.length) {
            return ($originalSlide.attr('data-title') || '').trim();
        }

        const $fallback = $slider.find('.swiper-slide').not('.swiper-slide-duplicate').eq(realIndex);
        return ($fallback.attr('data-title') || '').trim();
    }

    function setMainTitle(nextTitle, force = false) {
        if (!$mainTitle.length) return;

        const normalized = (nextTitle || '').trim();
        const current = ($mainTitle.text() || '').trim();

        if (!force && (!normalized || normalized === current)) return;

        if (titleAnimating && !force) {
            pendingTitle = normalized;
            return;
        }

        titleAnimating = true;
        $mainTitle.addClass('-is-hiding');

        setTimeout(() => {
            $mainTitle.text(normalized);
            $mainTitle.removeClass('-is-hiding').addClass('-is-showing');

            setTimeout(() => {
                $mainTitle.removeClass('-is-showing');
                titleAnimating = false;

                if (pendingTitle && pendingTitle !== normalized) {
                    const queued = pendingTitle;
                    pendingTitle = null;
                    setMainTitle(queued, true);
                } else {
                    pendingTitle = null;
                }
            }, 260);
        }, 220);
    }

    function updateMainTitle() {
        if (!swiper) return;

        const realIndex = Number.isFinite(swiper.realIndex) ? swiper.realIndex : 0;
        const nextTitle = getSlideTitleByRealIndex(realIndex);

        if (nextTitle) {
            setMainTitle(nextTitle);
        }
    }

    function initSwiper() {
        if (swiper) {
            try { swiper.destroy(true, true); } catch (e) {}
        }

        const SLIDES_COUNT = $slider.find('.swiper-wrapper > .swiper-slide').length;
        const MOBILE_SPV = 'auto';
        const DESKTOP_SPV = 2.14;
        const TABLET_SPV = 1.53;

        const LOOP_MIN = Math.ceil(DESKTOP_SPV * 2) + 1;
        const ENABLE_LOOP = SLIDES_COUNT >= LOOP_MIN;

        swiper = new Swiper($slider.get(0), {
            speed: 1000,
            loop: ENABLE_LOOP,
            slidesPerGroup: 1,
            slideToClickedSlide: !isMobile(),
            spaceBetween: 16,
            threshold: 8,
            roundLengths: true,
            centeredSlides: true,
            watchSlidesProgress: true,

            slidesPerView: MOBILE_SPV,
            effect: 'coverflow',

            coverflowEffect: isMobile() ? {
                rotate: 0,
                stretch: 50,
                depth: 20,
                scale: 0.95,
                modifier: 1,
                slideShadows: false
            } : undefined,

            breakpoints: {
                769: {
                    slidesPerView: TABLET_SPV,
                    effect: 'slide'
                },
                1440: {
                    slidesPerView: DESKTOP_SPV,
                    effect: 'slide'
                }
            },

            pagination: {
                el: '.section-slider-news .swiper-pagination',
                clickable: true
            },

            on: {
                init() {
                    if (ENABLE_LOOP && this.slideToLoop) this.slideToLoop(0, 0, false);
                    pauseAllVideos();

                    updateCenterState();
                    updateMainTitle();

                    requestAnimationFrame(() => {
                        updateCenterState();
                        updateMainTitle();
                    });

                    setTimeout(() => {
                        updateCenterState();
                        updateMainTitle();
                    }, 0);

                    setTimeout(() => {
                        updateCenterState();
                        updateMainTitle();
                    }, 80);
                },

                touchStart(sw) {
                    if (!sw || sw.allowTouchMove === false) return;
                },

                sliderFirstMove(sw) {
                    if (!sw || sw.allowTouchMove === false) return;

                    pauseAllVideos();

                    if (typeof sw.slideTo === 'function') {
                        sw.slideTo(sw.activeIndex, 0, false);
                    }
                },

                slideChangeTransitionStart() {
                    pauseAllVideos();
                },

                realIndexChange() {
                    updateMainTitle();
                },

                slideChangeTransitionEnd() {
                    updateCenterState();
                    updateMainTitle();
                },

                resize() {
                    updateCenterState();
                    updateMainTitle();
                }
            }
        });

    }

    function slideToSlideEl(slideEl) {
        if (!swiper || !slideEl) return;

        const real = parseInt(slideEl.getAttribute('data-swiper-slide-index') || '', 10);

        if (Number.isFinite(real) && typeof swiper.slideToLoop === 'function') {
            swiper.slideToLoop(real);
            return;
        }

        swiper.slideTo($(slideEl).index());
    }

    function pauseAllVideos() {
        $slider.find('video.video').each(function () {
            try { this.pause(); } catch (e) {}
        });
        $slider.find('.video-wrp').removeClass('-playing');
    }

    function updateCenterState() {
        if (!swiper) return;

        const $slides = $slider.find('.swiper-slide');
        if (!$slides.length) return;

        let centerEl = (swiper.slides && Number.isFinite(swiper.activeIndex))
            ? swiper.slides[swiper.activeIndex]
            : null;

        if (!centerEl) {
            centerEl = $slider.find('.swiper-slide-active').get(0);
        }

        if (!centerEl && Number.isFinite(swiper.realIndex) && swiper.slides && swiper.slides.length) {
            centerEl = Array.from(swiper.slides).find(el => {
                const di = parseInt(el.getAttribute('data-swiper-slide-index') || '', 10);
                return Number.isFinite(di) && di === swiper.realIndex;
            }) || null;
        }

        if (!centerEl) return;

        const $center = $(centerEl);

        $slides.removeClass('-center');
        $center.addClass('-center');

        $slides.not($center).find('.content').removeClass('-visible');
        $center.find('.content').addClass('-visible');

        $slides.not($center).find('.video-wrp').addClass('-disabled');
        $center.find('.video-wrp').removeClass('-disabled');
    }

    initSwiper();

    $(window).on('resize', (() => {
        let t;
        return () => {
            clearTimeout(t);
            t = setTimeout(() => {
                if (fsActive) return;
                initSwiper();
            }, 150);
        };
    })());

    function formatTime(s) {
        if (isNaN(s) || s === Infinity) return '00:00';
        s = Math.max(0, Math.floor(s));
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        const mm = (h ? String(m).padStart(2, '0') : String(m));
        const hh = String(h);
        const ss = String(sec).padStart(2, '0');
        return h ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`;
    }

    function setOnlyThisPlaying(currentVideo) {
        $slider.find('video.video').not(currentVideo).each(function () {
            try { this.pause(); } catch (e) {}
        });
    }

    $slider.find('.video-wrp').each(function () {
        const $wrap  = $(this);
        const $slide = $wrap.closest('.swiper-slide');
        const video  = $wrap.find('video.video').get(0);

        const $centerToggle = $wrap.find('.main-video-btn[data-action="toggle"]');
        const $barToggle    = $wrap.find('.video-bar [data-action="toggle"]');
        const $muteBtn      = $wrap.find('[data-action="mute"]');
        const $fsBtn        = $wrap.find('[data-action="fs"]');

        const $seekRange    = $wrap.find('.seek-range');
        const $seekBuffer   = $wrap.find('.seek-buffer');
        const $seekProgress = $wrap.find('.seek-progress');
        const $timeCur      = $wrap.find('.time .current');
        const $timeDur      = $wrap.find('.time .duration');

        $seekBuffer.css('width', '0%');
        $seekProgress.css('width', '0%');

        function writeDuration() {
            if (Number.isFinite(video.duration) && video.duration > 0) {
                $timeDur.text(formatTime(video.duration));
                return true;
            }
            return false;
        }

        if (!writeDuration()) {
            const onMeta = () => { if (writeDuration()) cleanup(); };
            const cleanup = () => {
                video.removeEventListener('loadedmetadata', onMeta);
                video.removeEventListener('loadeddata', onMeta);
                video.removeEventListener('canplay', onMeta);
                video.removeEventListener('durationchange', onMeta);
            };
            video.addEventListener('loadedmetadata', onMeta);
            video.addEventListener('loadeddata', onMeta);
            video.addEventListener('canplay', onMeta);
            video.addEventListener('durationchange', onMeta);

            const metaPoll = setInterval(() => {
                if (writeDuration()) {
                    clearInterval(metaPoll);
                    cleanup();
                }
            }, 250);

            video.addEventListener('play', () => {
                writeDuration();
                clearInterval(metaPoll);
                cleanup();
            }, { once: true });

            if (!video.getAttribute('preload')) video.setAttribute('preload', 'metadata');
            if (video.readyState === 0 && video.currentSrc) {
                try { video.load(); } catch (e) {}
            }
        }

        function ensureCenteredOrGoToSlideOnly() {
            if ($slide.hasClass('-center') || $slide.hasClass('swiper-slide-active')) return true;
            slideToSlideEl($slide.get(0));
            return false;
        }

        let lastTouchAt = 0;
        let swallowClickUntil = 0;
        let lastToggleAt = 0;

        let pointerDownX = 0;
        let pointerDownY = 0;
        let pointerMoved = false;
        let pointerIsDown = false;

        function getPointFromEvent(e) {
            const oe = e.originalEvent || e;

            if (oe.changedTouches && oe.changedTouches.length) {
                return {
                    x: oe.changedTouches[0].clientX,
                    y: oe.changedTouches[0].clientY
                };
            }

            if (oe.touches && oe.touches.length) {
                return {
                    x: oe.touches[0].clientX,
                    y: oe.touches[0].clientY
                };
            }

            return {
                x: oe.clientX,
                y: oe.clientY
            };
        }

        function stopEvt(e) {
            if (!e) return;
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        }

        $wrap.on('pointerdown touchstart mousedown', function (e) {
            const p = getPointFromEvent(e);
            pointerDownX = p.x;
            pointerDownY = p.y;
            pointerMoved = false;
            pointerIsDown = true;
        });

        $wrap.on('pointermove touchmove mousemove', function (e) {
            if (!pointerIsDown) return;

            const p = getPointFromEvent(e);
            const dx = Math.abs(p.x - pointerDownX);
            const dy = Math.abs(p.y - pointerDownY);

            if (dx > 8 || dy > 8) {
                pointerMoved = true;
            }
        });

        $wrap.on('pointerup pointercancel touchend touchcancel mouseup mouseleave', function () {
            pointerIsDown = false;
        });

        $wrap.on('click', function (e) {
            if (!isMobile()) return;
            const now = Date.now();
            if (now < swallowClickUntil) {
                stopEvt(e);
            }
        });

        function markTouchAndSwallow() {
            lastTouchAt = Date.now();
            swallowClickUntil = lastTouchAt + 900;
        }

        function canToggleNow() {
            const now = Date.now();

            if (isMobile()) {
                if ((now - lastToggleAt) < 350) return false;
                lastToggleAt = now;
                return true;
            }

            lastToggleAt = now;
            return true;
        }

        function togglePlay() {
            if (!ensureCenteredOrGoToSlideOnly()) return;

            if (!$wrap.hasClass('-started')) $wrap.addClass('-started');
            if (video.paused) {
                setOnlyThisPlaying(video);
                video.play();
            } else {
                video.pause();
            }
        }

        $wrap.on(isMobile() ? 'click touchend pointerup' : 'click', '[data-action="toggle"]', function (e) {
            if (isMobile()) {
                if (e.type === 'touchend' || e.type === 'pointerup') markTouchAndSwallow();
                if (e.type === 'click' && (Date.now() - lastTouchAt) < 900) {
                    stopEvt(e);
                    return;
                }
            }

            if (pointerMoved) {
                return;
            }

            stopEvt(e);

            if (!$slide.hasClass('-center')) {
                slideToSlideEl($slide.get(0));
                return;
            }

            if (!canToggleNow()) return;
            togglePlay();
        });

        $wrap.on(isMobile() ? 'click touchend pointerup' : 'click', 'video.video', function (e) {
            if (isMobile()) {
                if (e.type === 'touchend' || e.type === 'pointerup') markTouchAndSwallow();
                if (e.type === 'click' && (Date.now() - lastTouchAt) < 900) {
                    stopEvt(e);
                    return;
                }
            }

            // if it was a drag gesture, let swiper handle it, do not treat as click
            if (pointerMoved) {
                return;
            }

            stopEvt(e);

            if (!$slide.hasClass('-center')) {
                slideToSlideEl($slide.get(0));
                return;
            }

            if (!canToggleNow()) return;
            togglePlay();
        });

        $muteBtn.on('click', function (e) {
            e.preventDefault();
            video.muted = !video.muted;
            $wrap.toggleClass('-muted', video.muted);
            $(this).attr('aria-label', video.muted ? 'Unmute' : 'Mute');
        });

        function anyFS() {
            return document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
        }

        function enterFSOnVideo() {
            if (video.requestFullscreen) return video.requestFullscreen();
            if (video.webkitRequestFullscreen) return video.webkitRequestFullscreen();
            if (video.msRequestFullscreen) return video.msRequestFullscreen();
            if (video.webkitEnterFullscreen) { video.webkitEnterFullscreen(); return Promise.resolve(); }
            return Promise.reject();
        }

        function exitFS() {
            if (document.exitFullscreen) return document.exitFullscreen();
            if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
            if (document.msExitFullscreen) return document.msFullscreenElement;
        }

        $fsBtn.on('click', function (e) {
            e.preventDefault();
            if (anyFS()) {
                fsActive = false;
                swiper && (swiper.allowTouchMove = true);
                exitFS();
            } else {
                fsActive = true;
                swiper && (swiper.allowTouchMove = false);
                const p = enterFSOnVideo();

                if (p && p.catch) {
                    p.catch(() => {
                        fsActive = false;
                        swiper && (swiper.allowTouchMove = true);
                    });
                }
            }
        });

        const onFSChange = () => {
            const el = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
            const inside = !!el && (el === video || $wrap.has(el).length > 0);
            fsActive = !!el;
            swiper && (swiper.allowTouchMove = !fsActive);
            $wrap.toggleClass('-fs', inside);
        };
        $(document).on('fullscreenchange webkitfullscreenchange MSFullscreenChange', onFSChange);

        function updateProgressUI() {
            if (!isFinite(video.duration) || video.duration <= 0) return;
            const pct = (video.currentTime / video.duration) * 100;
            $seekRange.val(pct);
            $seekProgress.css('width', pct + '%');
            $timeCur.text(formatTime(video.currentTime));
            try {
                if (video.buffered && video.buffered.length) {
                    const end = video.buffered.end(video.buffered.length - 1);
                    const bufPct = Math.min(100, (end / video.duration) * 100);
                    $seekBuffer.css('width', bufPct + '%');
                }
            } catch (e) {}
        }

        video.addEventListener('timeupdate', updateProgressUI);
        video.addEventListener('progress', updateProgressUI);
        video.addEventListener('loadedmetadata', updateProgressUI);

        $seekRange.on('input mousedown touchstart', function () {});
        $seekRange.on('input', function () {
            if (!isFinite(video.duration)) return;
            const pct = parseFloat(this.value || '0');
            $seekProgress.css('width', pct + '%');
        });
        $seekRange.on('change mouseup touchend', function () {
            if (!isFinite(video.duration)) return;
            const pct = parseFloat(this.value || '0');
            video.currentTime = (pct / 100) * video.duration;
        });

        video.addEventListener('play', () => {
            $wrap.addClass('-playing').attr('data-state','playing');
            $centerToggle.attr('aria-label','Pause');
            $barToggle.attr('aria-label','Pause');
        });
        video.addEventListener('pause', () => {
            $wrap.removeClass('-playing').attr('data-state','paused');
            $centerToggle.attr('aria-label','Play');
            $barToggle.attr('aria-label','Play');
        });
        video.addEventListener('ended', () => {
            $wrap.removeClass('-playing').attr('data-state','ended');
        });

        $wrap.toggleClass('-muted', !!video.muted);
    });

    const io = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) pauseAllVideos();
        });
    }, { threshold: 0 }) : null;

    if (io) io.observe($section.get(0));
});